import React from 'react';
import { useUserOrdersLayout } from '../hooks';
import { UserOrdersLayout } from '../components/userOrders';

const UserOrders: React.FC = () => {
  const layoutProps = useUserOrdersLayout();

  return <UserOrdersLayout {...layoutProps} />;
};

export default UserOrders;
